
import actions from "./actions"
import mutations from "./mutations"

export default  {
    namespaced: true,

    state: () => ({ 
        layout: 'app',
        isShowAddOrUpdateModal: false,
        activityLogList: [],
     }),

    mutations: mutations,
    actions: actions,
    getters: { 
        isShowModal(state) {
            return state.isShowAddOrUpdateModal;
        },
     }
  }
